/**
 * Get role description for display, replacing "Any client on a job" with clearer text (ATT-193)
 */
export function getRoleDescription(description: string | undefined | null): string | undefined {
  if (!description) return undefined;
  return description.toLowerCase().includes('any client on a job')
    ? 'The homeowner or buyer you are scheduling for'
    : description;
}
